export default "__VITE_PUBLIC_ASSET__5ed12e8c__"